import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { NavbarProvider, useNavbar } from './contexts/NavbarContext';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import StormDash from './components/StormDash';
import Blog from './components/Blog';
import Admin from './components/Admin';
import Footer from './components/Footer';
import './App.css';

function AppContent() {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const { isVisible } = useNavbar();

  useEffect(() => {
    const handleScroll = () => {
      const heroSection = document.querySelector('.hero-section');
      if (heroSection) {
        const heroBottom = heroSection.offsetTop + heroSection.offsetHeight;
        const currentScroll = window.scrollY;
        
        // Show button when scrolled past hero section
        if (currentScroll > heroBottom * 0.8) {
          setShowScrollTop(true);
        } else {
          setShowScrollTop(false);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="App">
      {isVisible && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/storm-dash" element={<StormDash />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/admin-blog" element={<Admin />} />
      </Routes>
      {isVisible && <Footer />}
      
      {/* Scroll to top button */}
      <button 
        className={`scroll-to-top ${showScrollTop ? 'visible' : ''}`}
        onClick={scrollToTop}
        aria-label="Scroll to top"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M18 15l-6-6-6 6"/>
        </svg>
      </button>
    </div>
  );
}

function App() {
  return (
    <Router>
      <NavbarProvider>
        <AppContent />
      </NavbarProvider>
    </Router>
  );
}

export default App;
